"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Snackbar/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

const noop = () => undefined










const Snackbar = ({
  iconSrc,
  text,
  linkText,
  onAnyAction = noop,
  onLinkClick = noop,
  onClose = noop,
}) => {
  const handleClose = () => {
    onAnyAction()
    onClose()
  }

  const handleLinkClick = () => {
    onLinkClick()
    onAnyAction()
    onClose()
  }

  return (
    _react2.default.createElement('div', { className: "blmh-snackbar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
      , _react2.default.createElement('div', { className: "blmh-snackbar--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
        , _react2.default.createElement('img', { src: iconSrc, alt: "!", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} )
      )
      , _react2.default.createElement('span', { className: "blmh-snackbar--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}},  text )
      , _react2.default.createElement('a', { className: "blmh-snackbar--link", onClick: handleLinkClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}, linkText)
      , _react2.default.createElement('div', { className: "blmh-snackbar--close-icon", onClick: handleClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
        , _react2.default.createElement('img', { src: "/assets/icons/icon-xout-org.svg", alt: "x", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}} )
      )
    )
  )
}

exports. default = Snackbar
